import {
  AfterViewInit,
  Component,
  ViewChild,
  ViewContainerRef,
  ContentChild,
  forwardRef
} from "@angular/core";

import { ICellEditorAngularComp, AgRendererComponent } from "ag-grid-angular";
import * as moment from "moment";
import { ICellRendererParams } from "ag-grid/dist/lib/rendering/cellRenderers/iCellRenderer";
import { IAfterGuiAttachedParams } from "ag-grid/dist/lib/interfaces/iComponent";
import { IXSModalComponent } from "../../../ixsmodal/ixsmodal.component";
import { AgGridComponent } from "../../aggrid.component";
import { Enum, modalArgs } from "../../../config";
import { RowNode } from "ag-grid/dist/lib/entities/rowNode";
import { RowDataTransaction } from "ag-grid/dist/lib/rowModels/inMemory/inMemoryRowModel";
import { BaseComponent } from "../../../../core/component/Base.Component";
import {
  MessageBoxResultType,
  MessageBoxResult
} from "../../../messagebox/messagebox.config";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "actions-editor-cell",
  template: `
    <div class="divCenter">
      <a class="flat-icon-grid" (click)="disableView || viewScreen()" title="View" *ngIf="!hideView">
      <i class="fa fa-credit-card flat-icon-grid"></i>
      </a>
      <a class="flat-icon-grid" (click)="disableEdit || editScreen()" title="Edit" *ngIf="!hideEdit">
      <i class="fa fa-edit flat-icon-grid"></i>
      </a>
      <a class="flat-icon-grid" (click)="disableDelete || delete()" title="Delete" *ngIf="!hideDelete">
      <i class="fa fa-trash flat-icon-grid"></i>
      </a>
      <div>
      </div>
    </div>
  `,
  styles: [
    "a:hover{cursor:pointer} .divCenter{    text-align: -webkit-center; padding: 0px 6px 0 0;}"
  ]
})
export class GridActionsComponent extends BaseComponent
  implements AgRendererComponent {
  messageBoxSubscription: Subscription;

  refresh(params: any): boolean {
    return true;
  }
  agInit(params: ICellRendererParams): void {

    this.params = params;
    this.value = this.params.value;
    this.Grid = this.params.context;
    this.column = params.column;
    this.hideView = this.column.colDef.hideView;
    this.hideEdit = this.column.colDef.hideEdit;
    this.hideDelete = this.column.colDef.hideDelete;
    this.disableDelete = this.column.colDef.disableDelete;
    this.disableEdit = this.column.colDef.disableEdit;
    this.disableView = this.column.colDef.disableView;

    this.messageBoxSubscription = this.broadcast
      .observable<MessageBoxResult>("messageBoxResult")
      .subscribe(async arg => {
        switch (arg.value.id) {
          case ("deleteAction" + this.params.rowIndex).concat(
            this.Grid.name ? this.Grid.name : ""
          ):
            if (arg.value.result === MessageBoxResultType.yes) {
              await this.confirmDelete();
            }
            break;
        }
      });
  }
  afterGuiAttached(params?: IAfterGuiAttachedParams): void { }
  private params: ICellRendererParams;
  public value: any;
  private cancelBeforeStart: boolean = false;
  private Grid: AgGridComponent;
  hideView: boolean = false;
  hideEdit: boolean = false;
  hideDelete: boolean = false;
  disableView: boolean = false;
  disableEdit: boolean = false;
  disableDelete: boolean = false;
  private column: any;

  getValue(): any {
    return this.params.value;
  }

  valueChange(data) {
    this.params.setValue(this.value);
  }

  viewScreen() {
    this.Grid.myscreen.screen.myForm.disable();
    this.showScreen(Enum.Mode.Display);
  }

  editScreen() {
    this.Grid.myscreen.screen.myForm.enable();
    this.showScreen(Enum.Mode.Edit);
  }

  private async showScreen(mode) {
    this.params.setValue(Math.random());
    await this.Grid.myscreen.screen.clear();
    var node = this.Grid.options.api
      .getRenderedNodes()
      .filter(o => o === this.params.node)[0];
    if (node && node.data) {
      this.Grid.index = node.rowIndex;
      if (this.Grid.primeryKeyField) {
        const PrimaryKeyValue = node.data[this.Grid.primeryKeyField];
        this.Grid.myscreen.mode = mode;
        this.Grid.myscreen.screen.service.addDefaultCondition(
          this.Grid.primeryKeyField + " = @0",
          [PrimaryKeyValue]
        );
        this.Grid.myscreen.displayLastRecord = true;
        //this.Grid.index = this.params.rowIndex;

        var rowData = null;

        if (this.Grid.index !== -1) {
          //   rowData = this.Grid.options.api.getRowNode(this.Grid.index.toString())
          //     .data;
          rowData = this.Grid.options.api
            .getRenderedNodes()
            .filter(o => o.rowIndex === this.Grid.index)[0].data;
        }

        this.Grid.actionOpen.emit(<modalArgs>{
          modal: this.Grid.myscreen,
          rowData: rowData,
          cancel: false
        });
        this.Grid.startLoading();
        await this.Grid.myscreen.open();
        this.Grid.stopLoading();
      }
    }
  }

  async delete() {
    await this.showYesNo(
      ("deleteAction" + this.params.rowIndex).concat(
        this.Grid.name ? this.Grid.name : ""
      ),
      "Are you sure you want to delete!",
      "Warning"
    );
  }

  async confirmDelete() {
    this.Grid.myscreen.screen.service.clearCondition();
    var node = this.Grid.options.api
      .getRenderedNodes()
      .filter(o => o === this.params.node)[0];
    if (node && node.data) {
      if (this.Grid.primeryKeyField) {
        const PrimaryKeyValue = node.data[this.Grid.primeryKeyField];
        const result = await this.Grid.myscreen.screen.service.delete(
          PrimaryKeyValue
        );
        if (result.IsSuccess) {
          this.showSuccess("record successfully deleted");
          if (this.Grid.options.api) {
            const node = this.Grid.options.api
              .getRenderedNodes()
              .filter(o => o === this.params.node)[0];

            this.Grid.options.api.removeItems([node]);
            if (this.Grid._data) {
              const index = this.Grid._data.indexOf(node.data);

              if (index !== -1) {
                this.Grid._data.splice(index, 1);
              }
            }

            this.Grid.generateIndex(0);
          }
        } else {
          this.showErrors(result.Errors);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.messageBoxSubscription) {
      this.messageBoxSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/grid/editors/actions/actionscomponent.ts